import { FLIGHT_DETAILS_RETRYABLE_ERROR_CODES, RETRY_NETWORK_ERROR_FOR_GAPD } from "../constants.js";
import { useSelector } from "react-redux";
import { getFlightDetailsFetchStatus, getFlightError } from "../store/flightDetails/selectors.js";
import { flightsSessionStore } from "@flights/web-api-utils-universal";
export default function useRetryFlightDetailsApi() {
    const fetchStatus = useSelector(getFlightDetailsFetchStatus);
    const error = useSelector(getFlightError);
    const serviceError = error;
    const isRetryableFlightDetails = () => {
        if (fetchStatus == "failed" &&
            FLIGHT_DETAILS_RETRYABLE_ERROR_CODES.includes(serviceError?.code) &&
            flightsSessionStore.get(RETRY_NETWORK_ERROR_FOR_GAPD)) {
            return true;
        }
        return false;
    };
    const setFlightDetailsApiForRetry = (error) => {
        if (FLIGHT_DETAILS_RETRYABLE_ERROR_CODES.includes(error.code)) {
            flightsSessionStore.set(RETRY_NETWORK_ERROR_FOR_GAPD, true);
        }
    };
    const unSetFlightDetailsApiForRetry = () => {
        flightsSessionStore.unset(RETRY_NETWORK_ERROR_FOR_GAPD);
    };
    return {
        isRetryableFlightDetails,
        setFlightDetailsApiForRetry,
        unSetFlightDetailsApiForRetry
    };
}
